import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/financial-ratios-calculator',
  component: () => import('../../routes/FinancialRatiosCalculator.svelte'),
  card: {
    id: 'financial-ratios',
    title: 'Financial Ratios',
    description: 'Calculate key financial ratios including liquidity, leverage, and profitability metrics from balance sheet and income statement data.',
    icon: 'analytics',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/financial-ratios-calculator',
    category: 'Business',
  },
  seo: {
    title: 'Financial Ratios Calculator – Liquidity, Leverage & Profitability',
    description: 'Free financial ratios calculator. Calculate current ratio, quick ratio, debt-to-equity, profit margin, ROA, ROE, and more from your balance sheet and income statement data.',
  },
};

export default meta;